import _asyncToGenerator from "/data/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, mergeProps as _mergeProps, isRef as _isRef } from "vue";

const _hoisted_1 = /*#__PURE__*/_createTextVNode("查询");

const _hoisted_2 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_3 = /*#__PURE__*/_createTextVNode("确认");

import { ref, computed, watch } from 'vue';
import { useStore } from 'vuex';
import { getVexTableProps } from '@/config';
import { getTeamList, getCatalog, getDistributorList } from '@/request';
import { ElMessage } from 'element-plus';
export default {
  name: 'AddTeamModal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    beforeSuccess: {
      type: [Function, null],
      default: null
    },
    selectedIds: {
      type: Array,
      default: () => []
    },
    businessCategory: {
      type: String,
      default: ''
    }
  },
  emits: ['update:modelValue', 'success'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const store = useStore();
    store.dispatch('getDictList');
    const dictList = computed(() => store.state.dictList);
    const table = ref();
    const visible = computed({
      get() {
        return props.modelValue;
      },

      set(val) {
        emit('update:modelValue', val);
      }

    });
    const form = ref({
      supplierKeyWd: '',
      supplierCategory: '',
      branchId: ''
    });
    const teamTypes = ref([]);
    const teamTypeMap = ref(new Map());
    const branchList = ref([]);

    const getTeamTypes = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(function* () {
        try {
          const data = yield getCatalog({
            type: 'supplierCategory'
          });

          if (data) {
            teamTypes.value = data;
            teamTypeMap.value = new Map(data.map(item => [item.value, item.text]));
          }
        } catch (error) {
          console.error('获取团队类型失败:', error);
        }
      });

      return function getTeamTypes() {
        return _ref.apply(this, arguments);
      };
    }();

    const getBranchList = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(function* () {
        try {
          const data = yield getDistributorList({
            rows: 1000
          });

          if (data) {
            branchList.value = data.rows.map(item => ({
              text: item.branchName,
              value: item.branchId
            }));
          }
        } catch (error) {
          console.error('获取商业公司失败:', error);
        }
      });

      return function getBranchList() {
        return _ref2.apply(this, arguments);
      };
    }();

    watch(() => props.modelValue, newVal => {
      if (newVal) {
        form.value = {
          supplierKeyWd: '',
          supplierCategory: ''
        };
        getTeamTypes();
        getBranchList();
      }
    });
    const tableOptions = getVexTableProps({
      columns: [{
        type: 'checkbox',
        width: '50px'
      }, {
        title: '团队名称',
        field: 'supplier_name',
        width: '250px',
        showOverflow: true
      }, {
        title: '团队类型',
        field: 'supplier_category',
        width: '120px',
        showOverflow: true,
        formatter: ({
          cellValue
        }) => {
          return teamTypeMap.value.get(cellValue) || cellValue;
        }
      }, {
        title: '业务员数量',
        field: 'salesman_num',
        width: '100px',
        showOverflow: true
      }, {
        title: '联系人',
        field: 'link_man',
        width: '150px',
        showOverflow: true
      }, {
        title: '联系电话',
        width: '150px',
        field: 'link_phone',
        showOverflow: true
      }, {
        title: '业务区域',
        width: '250px',
        field: 'businessAreaName',
        showOverflow: true
      }],
      proxyConfig: {
        ajax: {
          query: ({
            page
          }) => new Promise(res => {
            getTeamList({
              page: page.currentPage,
              rows: page.pageSize,
              supplierKeyWd: form.value.supplierKeyWd,
              businessCategory: props.businessCategory,
              supplierCategory: form.value.supplierCategory,
              branchId: form.value.branchId
            }).then(data => {
              var _data$rows;

              data === null || data === void 0 ? void 0 : (_data$rows = data.rows) === null || _data$rows === void 0 ? void 0 : _data$rows.forEach(row => {
                row.id = row.supplier_id;
                row.submit_type = 'team';
              });
              res({
                total: data.total,
                result: data.rows
              });
            });
          })
        }
      },
      checkboxConfig: {
        checkMethod({
          row
        }) {
          return !props.selectedIds.find(i => i === row.id);
        }

      }
    });

    function confirm() {
      const selectRows = table.value.getCheckboxRecords();

      if (!selectRows.length) {
        ElMessage.warning('请勾选后再进行操作!');
        return;
      }

      if (typeof props.beforeSuccess === 'function') {
        if (props.beforeSuccess(selectRows)) {
          emit('success', selectRows);
          visible.value = false;
        }
      } else {
        emit('success', selectRows);
        visible.value = false;
      }
    }

    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_form = _resolveComponent("el-form");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createBlock(_component_el_dialog, {
        title: "添加团队",
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _isRef(visible) ? visible.value = $event : null),
        "destroy-on-close": "",
        "append-to-body": "",
        width: "1000px",
        top: "30px"
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[4] || (_cache[4] = $event => visible.value = false)
        }, {
          default: _withCtx(() => [_hoisted_2]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: confirm
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        })]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          inline: true
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "团队名称"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.value.supplierKeyWd,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value.supplierKeyWd = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "团队类型"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: form.value.supplierCategory,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.value.supplierCategory = $event),
              placeholder: "请选择",
              clearable: ""
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(teamTypes.value, item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: item.value,
                  label: item.text,
                  value: item.value
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "商业公司"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: form.value.branchId,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.value.branchId = $event),
              placeholder: "请选择",
              filterable: "",
              clearable: ""
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(branchList.value, item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: item.value,
                  label: item.text,
                  value: item.value
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: ""
          }, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              icon: "Search",
              type: "primary",
              onClick: _cache[3] || (_cache[3] = $event => table.value.commitProxy('reload'))
            }, {
              default: _withCtx(() => [_hoisted_1]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_vxe_grid, _mergeProps({
          height: "630px",
          ref_key: "table",
          ref: table
        }, _unref(tableOptions)), null, 16)]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }

};